var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group little-round flex-row-center",class:{ 'disabled': _vm.disabled, 'error': _vm.error, 'active': _vm.active },style:({ 'width': _vm.width ? (_vm.width + "px") : 'auto' })},[_c('div',{staticClass:"namelabel",domProps:{"innerHTML":_vm._s(_vm.name)}}),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e95df0f8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/UI/Group.vue
// module id = null
// module chunks = 